import { FuseNavigationItem } from '../../../../../shared/src/lib/@fuse/components/navigation';
import { Formation } from '../../../../../shared/src/lib/model/formation.model';

/**
 * Génère la navigation dynamique pour l'esp ace Student
 * La formation courante est gérée par NgRx Store (pas besoin de formationId dans l'URL)
 * 
 * Routes simples : /dashboard, /sessions/upcoming, /sessions/past, etc.
 * Les badges dynamiques sont gérés dans le composant layout
 */
export function getStudentNavigation(
    currentFormation: Formation | null, 
    hasPastOccurrences: boolean = false,
    hasReportExist: boolean = false
): FuseNavigationItem[] {
    if (!currentFormation) {
        return [];
    }

    const isStandardMode = currentFormation.mode_formation === 'standard';
    const isLilateMode = currentFormation.mode_formation === 'lilate';

    return [
        {
            id: 'nav-dashboard',
            title: isLilateMode ? 'lingueopro.nav.dashboard-lilate' : 'lingueopro.nav.dashboard-lilate',
            type: 'basic',
            icon: 'heroicons_outline:home',
            link: '/dashboard'
        },
        {
            id: 'nav-upcoming',
            title: isLilateMode ? 'lingueopro.nav.next-lessons-lilate' : 'lingueopro.nav.next-lessons',
            type: 'basic',
            icon: 'heroicons_outline:calendar',
            link: '/sessions/upcoming'
        },
        {
            id: 'nav-past',
            title: isLilateMode ? 'lingueopro.nav.past-lessons-lilate' : 'lingueopro.nav.past-lessons',
            type: 'basic',
            icon: 'heroicons_outline:clock',
            link: '/sessions/past',
            disabled: !hasPastOccurrences  // Désactiver si pas de cours passés
        },
        {
            id: 'nav-progress',
            title: isLilateMode ? 'lingueopro.nav.progression-lilate' : 'lingueopro.nav.progression',
            type: 'basic',
            icon: 'heroicons_outline:chart-bar',
            link: '/progression',
            disabled: !hasReportExist  // ✅ Désactiver si pas de rapport d'évaluation
        },
        {
            id: 'nav-messages',
            title: 'lingueopro.nav.contact-teacher',
            type: 'basic',
            icon: 'heroicons_outline:chat-bubble-left-right',
            link: '/messages'
            // Badge dynamique géré dans le layout (nbMessagesUnread)
        },
        {
            id: 'nav-sheets',
            title: 'lingueopro.nav.sheets',
            type: 'basic',
            icon: 'heroicons_outline:document-text',
            link: '/sheets'
            // Visibilité gérée dynamiquement avec checkFeaturePermission('sheets') et checkAvailableLanguageSheets()
        },
        {
            id: 'nav-exercices',
            title: 'nav.Exercices',
            type: 'basic',
            icon: 'heroicons_outline:pencil-square',
            link: '/exercices'
            // Visibilité gérée dynamiquement avec checkFeaturePermission('sheets')
        }
    ];
}
